import React from 'react';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';
import Link from '@amzn/meridian/link';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div style={{ textAlign: 'center', paddingTop: '80px' }}>
            <Heading level={1}>404</Heading>
            <Text>The page you're looking for doesn't exist.</Text>
            <br />
            <Link onClick={() => navigate('/')}>Go to Home</Link>
        </div>
    );
};

export default NotFound;
